import React from "react";
import "./AboutCard.scss";
import IMG from "../../../assets/about/about2.png";
import { GOOGLE_REVIEWS_URL } from "../../../constants/gmb";
import { useGmbReviews } from "../../../context/GmbReviewsContext";

export default function AboutCard() {
  const { featuredReviews, loading, hasData } = useGmbReviews();

  return (
    <div className="cardAboutBase">
      <div className="cardAboutContent">
        <div className="cardAboutLeftGrid">
          <div className="imgAboutBase">
            <img src={IMG} alt="cardImg" className="cardAboutImg" />
          </div>
        </div>
        <div className="cardAboutRightGrid">
          <div className="textAboutBase">
            {!loading && featuredReviews.length > 0 ? (
              featuredReviews.map((review) => (
                <React.Fragment key={review.id}>
                  <p className="cardAboutTxt">{review.comment}</p>
                  <p className="cardAboutTxt">{review.firstName}</p>
                  <p className="cardAboutSubTxt">{review.monthLabel}</p>
                </React.Fragment>
              ))
            ) : (
              <>
                <p className="cardAboutTxt">
                  The RRR team did a wonderful job remodeling and painting our new
                  home and working in a short span of time. We would use them again
                  and highly recommend! Very knowledgeable building professionals on
                  the jobsite , we had a lot of confidence in their skill and
                  competencies.
                </p>
                <p className="cardAboutTxt">Diane K.</p>
                <p className="cardAboutSubTxt">A happy customer</p>
              </>
            )}

            <a href={GOOGLE_REVIEWS_URL} style={{ textDecoration: "none" }}>
              <button className="blueBtn" style={{ marginTop: "20px" }}>
                {hasData
                  ? "See what our customers have to say"
                  : "See what our cutomers have to say"}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
